import { render, staticRenderFns } from "./RiotHeaderNav.vue?vue&type=template&id=589e9e78&"
import script from "./RiotHeaderNav.vue?vue&type=script&lang=js&"
export * from "./RiotHeaderNav.vue?vue&type=script&lang=js&"
import style0 from "./RiotHeaderNav.vue?vue&type=style&index=0&id=589e9e78&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports